import React, { useContext } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { PacingContext } from "./PpcPacing";


export default function SaveChanges(props) {
  const pacingContext = useContext(PacingContext);
  return (
      <Col className="text-center px-md-3 px-0">
          <Button
            className="save-btn"
            onClick={() => {pacingContext.submitForm(); props.setShowBox(false)}}
            as="input"
            type="submit"
            value="Save"
            variant="success"
            id="ppc-pacing-save-btn"
          />
      </Col>
  );
}
